import { updateObject } from '../../shared/utility';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
    token: null,
    userUid: null,
    connectedUserId:null,
    login: null,
    error: null,
    loading: false,
    userType: null,
    userRoles: null,
    authRedirectPath: null,
    status: null,
  access_data_key: null,
  access_data_assu_key:null,
    enquete_id: null,
    logoutUrl:null,
    bailleur_id: null,
    logo: null,
    URL: null,
    libelleCourt:null


}

const authStart = (state, action) => {
    return updateObject(state, {error: null, loading: true, authRedirectPath: null});
}

const authSuccess = (state, action) => {
    return updateObject(state, {
        connectedUserId: action.connectedUserId,
        login: action.login,
        error: null,
        loading: false,
        userType: action.userType,
        userRoles: action.userRoles,
      access_data_key: action.access_data_key,
      access_data_assu_key: action.access_data_assu_key,
        bailleur_id: action.bailleur_id,
        enquete_id: action.enquete_id,
        logoutUrl: action.logoutUrl,
        logo: action?.logo,
        URL: action?.URL,
        libelleCourt: action?.libelleCourt  
       
    })
}



const authFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        connectedUserId: null,
        login: null,
        loading: false,
        userType: null,
        userRoles: null,
      access_data_key: null,
      access_data_assu_key:null,
        bailleur_id: null,
        enquete_id: null,
      
        authRedirectPath: "/"
    })
}

const authLogout = (state, action) => {
    //return updateObject(state, {token: null, userId: null})
    return updateObject(state, {
        token: null, 
        connectedUserId:null,
        userUid: null, 
        login: null,
        loading: false, 
        userType: null,
        userLevel: null,
        bailleur_id:null,
      access_data_key: null,
      access_data_assu_key: null,
        userRoles:null,
        authRedirectPath: "/"
    })
}

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, {authRedirectPath: action.path})
}


const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.AUTH_START: return authStart(state, action)
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action)
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_LOGOUT: return authLogout(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state, action)
        default:
            return state
    }
}

export default reducer;
